var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAttraversamentoRed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 30 30",
    style: {
      enableBackground: "new 0 0 30 30"
    },
    xmlSpace: "preserve",
    width: "30px",
    height: "30px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#E53929;stroke:#1D1D1B;stroke-width:2;stroke-miterlimit:10;}\r\n\t.st1{fill:none;stroke:#1D1D1B;stroke-width:2;stroke-miterlimit:10;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M13,2.4c2.2-0.5,4.6-0.3,6.6,0.7c1.9,0.9,3.5,2.4,4.5,4.2c1,1.8,1.5,3.9,1.2,6c-0.2,1.8-1,3.4-2,4.9 c-0.9,1.3-1.9,2.5-2.9,3.7c-1.7,2-3.4,4.1-5.1,6.1c-2-2.1-4-4.3-5.9-6.5c-1.3-1.5-2.5-3-3.3-4.8c-0.8-1.8-1.1-3.8-0.8-5.8 c0.3-2.1,1.2-4,2.7-5.5C9.3,3.8,11.1,2.8,13,2.4"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 6,
    y1: 8.3,
    x2: 24,
    y2: 8.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 4.4,
    y1: 11.7,
    x2: 25.6,
    y2: 11.7
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttraversamentoRed);
export default __webpack_public_path__ + "static/media/attraversamento_red.c8d30cbcbc3cb1733feaa49759814163.svg";
export { ForwardRef as ReactComponent };